/* istanbul ignore file */
/** For mobile */
export var ChallengeKeyboardType;
(function (ChallengeKeyboardType) {
    ChallengeKeyboardType["Alphanumeric"] = "default";
    ChallengeKeyboardType["Numeric"] = "numeric";
})(ChallengeKeyboardType || (ChallengeKeyboardType = {}));
